import React from 'react';
import { HiEye } from 'react-icons/hi';
import { FaGithub } from 'react-icons/fa';
import { BsArrowRight } from 'react-icons/bs';

function ProjectCard({ project, featured = false }) {
  return (
    <div className={`project-card ${featured ? 'featured' : ''}`}>
      <div className="project-image-container">
        <img src={project.image} alt={project.title} className="project-image" />
        <div className="project-overlay">
          <div className="project-icons">
            {project.frameworks.map((Framework, index) => (
              <Framework key={index} className="framework-icon" />
            ))}
          </div>
          <div className="project-actions">
            <a href={project.link} target="_blank" rel="noreferrer" className="action-btn">
              <HiEye />
            </a>
            {project.github && (
              <a href={project.github} target="_blank" rel="noreferrer" className="action-btn">
                <FaGithub />
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="project-content">
        <div className="project-type">
          {project.typeIcon} {project.type}
        </div>
        <h3 className="project-title">{project.title}</h3>
        <p className="project-description">{project.description}</p>
        <a href={project.link} target="_blank" rel="noreferrer" className="project-link">
          View Project <BsArrowRight />
        </a>
      </div>
    </div>
  );
}

export default ProjectCard;
